import addMoneyMask from "../../../../utils/addMoneyMask";

const PlanCardTitle = ({ plan }) => {
  return (
    <div className="carousel-plan-title">
      <span className="carousel-plan-text">Crédito de</span>
      <span className="carousel-plan-strong">
        {addMoneyMask(plan.bemValor)}
      </span>
      <div>
        <span className="carousel-plan-text">em até </span>
        <b className="carousel-plan-parcel">{plan.planoMeses} meses</b>
      </div>
    </div>
  );
};

export default PlanCardTitle;
